import { useEffect, useRef, useState } from 'react'

/**
 * Returns a ref + a flag that flips true right after mount.
 *
 * Deliberately NOT IntersectionObserver / rAF / innerHeight based — those are
 * throttled or zeroed in some embedded/preview renderers, which left content
 * stuck invisible. A plain useEffect runs on React's own scheduler regardless
 * of page visibility, so content is guaranteed to reveal everywhere. Because
 * passive effects run after the first paint, the opacity:0 frame is painted
 * first and the CSS transition still animates in for real users. Per-element
 * `delay` in <Reveal/> produces the staggered cascade. `ref` kept for API compat.
 */
export function useInView() {
  const ref = useRef(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    setInView(true)
  }, [])

  return { ref, inView }
}
